import {getCityHexKeys} from "../getCityHexKeys";

/**
 * Города противников, до которых дотянулись пути влияния гильдии/храма.
 * Путь из calculateInfluencePathIncome заканчивается ячейкой достигнутого
 * города, поэтому город определяется по последней ячейке пути.
 *
 * @param {Array<Array<string>>} influencePaths - пути влияния (см. calculateInfluencePathIncome)
 * @param {Object} citiesCache - кэш городов
 * @param {string} ownerColor - цвет владельца гильдии/храма (его города пропускаются)
 * @returns {Array<{playerColor: string, hexKeys: string[]}>} города с цветом владельца
 */
export const getInfluencedEnemyCities = (influencePaths, citiesCache, ownerColor) => {
  const reachedHexKeys = new Set(
    (influencePaths || [])
      .filter(path => path && path.length > 0)
      .map(path => path[path.length - 1])
  );

  if (reachedHexKeys.size === 0) {
    return [];
  }

  const influencedCities = [];

  Object.entries(citiesCache || {}).forEach(([playerColor, cities]) => {
    if (playerColor === ownerColor) {
      return;
    }

    cities.forEach(city => {
      const cityHexKeys = getCityHexKeys(city);
      const isInfluenced = [...reachedHexKeys].some(hexKey => cityHexKeys.has(hexKey));
      if (isInfluenced) {
        influencedCities.push({playerColor, hexKeys: [...cityHexKeys]});
      }
    });
  });

  return influencedCities;
};
